export const GET_OTP = 'getOTP';
export const VERIFY_OTP = 'verifyOTP';
export const SET_USER_INFO = 'setUserInfo';
export const CHECK_PHONE = 'checkPhone';
